const legs = Array.from({ length: 10 }).map((_, i) => ({
  //Default values. Overwritten further down.
  id: i + 1,
  index: i,
  title: `Etappe ${i + 1}`,
  gpsLink: "https://www.tulospalvelu.fi/gps/2025tiomilaH" + (i + 1) + "/",
  graphImage: "./Leg" + (i + 1) + "_graph.png",

  text: [
    {
      desc: "",
      content: "",
    },
    {
      desc: "",
      content: "",
    },
    {
      desc: "",
      content: "",
    },
    {
      desc: "",
      content: "",
    },
  ],
  runnerImage: "TODO",
  runnerName: "Navn Navnesen",
  gpsMapPath: "TODO",
  graphCaption: "TODO",
}));

Object.assign(legs[0], {
  text: [
    {
      desc: "Oppladning:",
      content: (
        <>
          Kjørte ned på onsdagen for et par dager med precamp. Bra opplegg der.
          Fikk et o-løp på torsdag som sikkert var bra som gjennomkjøring, selv
          om det gjorde at det ble litt færre økter nærme Finspång. Formen
          kjentes bedre enn på lenge, og følte jeg hadde grei kontroll på
          terrenget. Følte meg bra på oppvarming også, og var ganske avslappa
          selv om jeg alltid blir litt mer nervøs når det er 1. etappe. Hadde
          ikke noen konkret taktikk annet enn å løpe sikkert og være med i
          teten, vanskelig å planlegge veldig når alle starter samtidig.
        </>
      ),
    },
    {
      desc: "",
      content: "",
    },
    {
      desc: "Løpet:",
      content: (
        <>
          Ser fort at jeg skal høyre til 1., evt. den lille stien og så rett på
          hvis de andre drar der. Skjønte ikke så mye av det som skjedde på
          startpost egentlig, men alle foran meg løp rett fram og jeg ble med
          der (syntes høyresvingen var litt slak, men kunne ikke skjønne at man
          nesten skulle snu for å komme på riktig sti). Oppdaga fort at jeg var
          kommet feil da køen bak delte seg, men hadde kommet såpass langt at
          jeg tenkte det var for seint å snu (feilslutning). Regna med noen
          flere kom til å ta av, så avventa litt med å kutte, noe som gjorde at
          det ble lenger vei gjennom det (lyse)grønne. Kom til slutt ut på andre
          sida, og havna midt inni klynga. Hadde ikke helt kontroll på hvor jeg
          kryssa veien, og måttte bortom og sjekke en ungdomspost før jeg fant
          min. Usikker på hvor mye jeg hadde tapt, men skjønte i hvert fall at
          jeg måtte kjøre på for å ha mulighet til å komme opp igjen.
          <br /> Løper alt jeg kan til 2. og 3. Heldigvis ikke så vanskelig
          orientering, men mye folk i veien. Passerer lag jeg absolutt ikke
          burde være sammen med, men prøver å ikke tenke for mye på det, vet at
          jeg sannsynligvis ikke er så alt for langt bak i tid og burde kunne ta
          inn en del hvis jeg løper bra. Ordentlig gafla etter 5. post, og
          kommer nesten alene inn mot 6. etter litt dårlig retning etter veien.
          Får roet meg ned og orienterer bra gjennom resten av gaflinga. Inn mot
          11. post ser jeg endelig noen litt bedre lag, og begynner å få litt
          trua. Løper ganske rett på til 12., som de fleste andre rundt meg.
          Hadde ikke sett så mye på strekket, men veivalget ble ganske bra
          (beste strekktid!) – vurderte egentlig aldri å løpe rundt, og det
          lønte seg heller ikke. Inn mot posten kommer det en hel gjeng fra
          venstre, det viste seg å være teten som hadde løpt en omgående
          variant. Kommer inn på halen og løper meg oppover i feltet med sånn
          halvveis kartkontakt gjennom 13. og 14. Usikker på veivalget til 15.,
          men blir med klynga på stien (GPS-sporet er skeivt, løp på stien hele
          veien). Mister litt oversikten over hvordan jeg ligger an etter dette,
          men ser jevnlig mange av de antatt beste lagene så regner med det
          fortsatt er samla. Viste seg at to stk. hadde fått ei bra luke på den
          litt kortere G-varianten. Litt feil retning ut av 17. og dårlig trasé
          til 19. gjør at jeg taper ytterligere med tid til dem. Dårlig spurt
          (hadde ikke mer å gi), og kommer til veksling 1:15 bak tet, men bare
          32 s bak Helsingin Suunnistajat på 3. Godkjent det.
        </>
      ),
    },
    {
      desc: "Erfaringer:",
      content: (
        <>
          Viktig å klare å omstille seg fort etter at noe uforutsett skjer; selv
          om jeg klarte å ta meg sammen etter 1. post kunne jeg ha redusert
          tidstapet og risikoen ved å snu med en gang jeg skjønte jeg løp feil i
          starten eller ha bedre kontroll ut av det grønne. En annen ting man
          kan ta med seg er at det ikke er krise om det går dårlig i starten,
          løypa og stafetten er lang nok til at man fint kan hente inn et minutt
          eller to. Samtidig er det sjelden det blir avgjort på de første
          postene, så man er lurt å ta seg tid til å komme ordentlig inn på
          kartet i starten heller enn å stresse med å ligge først. Ellers burde
          jeg kanskje ha sett på starten ungdomskavlen, da kunne jeg sikkert
          fått med meg hvordan det så ut ved startpost.
          <br />
          <br />
          Når det gjelder laget generelt, så er vi stabile o-løpere som også er
          blant de beste fysisk på respektive etapper. Vi klarer å holde oss
          langt framme hele veien, fordi alle gjør greie løp uten store bommer.
          Da er det inigen sak å vinne tio når Eirik er i støtet på siste
          etappe.
        </>
      ),
    },
  ],
  runnerName: "Nils Tveite",
  runnerImage: "Nils-1024x715.jpg",
  gpsMapPath: "NilsGPS.jpg",
  graphCaption: "Nils (grønn) vs top 10 første etappe (felles poster).",
});

Object.assign(legs[1], {
  text: [
    {
      desc: "Forberedelser og vintertrening:",
      content:
        "For min del begynte forberedelsene allerede i oktober da jeg egentlig bestemte meg for at jeg skal komme på laget og løpe en god etappe for at jeg skal kunne være fornøyd med sesongen og at det er det eneste som gjelder. Jeg har stor troa på at hvis man skal få fremgang og oppnå målene sine må man først overtale seg selv (og være litt naiv), ellers blir det umulig. Med det i bakhodet gikk jeg inn i vintertreningen med planer om å spise mer og skru opp mengden, distanse og frekvens på øktene, noe jeg føler har gitt god uttelling på kapasiteten. Har klart å være sykdomsfri og skadefri hele vinteren, noe som selvfølgelig også har gitt selvtillit på grunnformen og ført til at jeg i stedet har klart å fokusere på å utvikle teknikken i ukene før tio. På samlinger før tio jobbet jeg mye med offensiv kartlesing og å bli komfortabel med orientering i overfart, noe jeg alltid har vært litt dårlig på, men som jeg følte kom seg litt denne våren.",
    },
    {
      desc: "Precamp:",
      content:
        "Med solide kvitteringer fra Østfold-samling og stigtomtakavlen kom jeg til precamp med ro og selvtillit der de eneste målene egentlig var å samle overskudd og forberede meg mentalt. Gikk hele uken å overtale meg selv om at jeg er sterkest og best teknisk på min etappe for å bygge selvtillit, hvilket gav en god positiv effekt. Har tidligere slitt med å ha for mye «respekt» for eldre og bedre løpere og har derfor ikke hatt troa på at jeg kan løpe like gode løp eller etapper som dem. Har liksom sett meg selv som en 2e-klasse løpere og derfor har løpene som regel også resultert sånn. Så den uken prøvde jeg egentlig å bare miste den så godt jeg klarte. Treningsmessig løp jeg et par korte o-hardøkter og ellers bare 40min jogger her og der. Ingenting spesielt og form er ingenting jeg synes jeg kan endre på en uke uansett.",
    },
    {
      desc: "Løpet:",
      content:
        "Var litt nervøs på oppvarmingen, men mest bare veldig gira. Tross for det prøvde jeg bare å varme opp som vanlig og komme inn i race-modus. Fulgte med hvor Nils lå og ble fornøyd når jeg fikk ett drøyt minutt opp å jakte mot, et scenario jeg liker og har vært i mange ganger før.\n\nGår ut hardt som nr 20 i midten på en stor klynge og ser at første post er veldig lik det jeg hadde trodd på forhånd, skjønner fort at jeg skal gå høyere og blir fornøyd når jeg får mulighet til å plukke plasseringer allerede opp første bakken. Gikk ikke fryktelig fort, hvilket bekreftet det jeg tenkt på hele uken før. 3e post er felles og jeg har jobbet meg opp tet på gruppa sammen med Linne, IFK og SNO, men vet også at det er et par lag lenger foran som må hentes inn. 4-5e post går enda saktere og jeg er ikke helt fornøyd over det så prøver å dra opp farten litt, men går i stedet på en 50s bom til 6e post. Blir litt irritert, men tar meg sammen og finner Oliver til 7e post. Veksler litt postkoder, finner fort ut at vi har samme gafling, trøkker litt og flyter gjennom det grønne og tekniske, så er vi snart oppe i tet på gruppa igjen. Prøver her mest bare å ta detaljer, stole på at alle andre bommer og tro at jeg løper fortest. Får andretid på gafling-segmentet mellom 6e og 11 post så oppskriften fungerte. 12e post er langstrek over hogst og ser der at Paimion Rasti er 200m foran. Kjenner jeg har mer fart igjen og prøver å øke farten litt mer. Tar etterhvert igjen Paimion Rasti også og innser at jeg ligger i tet ved 12e og 13e post hvor jeg da prøver å roe meg ned litt for å sikre de siste postene. Til 14e post tar jeg høyere om myren, noe jeg tydeligvis tapte noen meter på og Kalevan Rasti er før meg ved posten. Den viser seg også å være gaflet sånn at jeg må 50m ekstra etter jeg var på den første gaflingsposten. Blir litt hissig når jeg prøver å ta igjen de meterne, men får passeringsposten bra. Dessverre blir det på bekostning av at jeg ikke leser kartet til 16e post nøyaktig nok. Ser ikke første stien på kartet og stopper opp altfor tidlig for å se etter posten siden jeg tror den første stien er den andre som kommer etter posten. Mister 30s her og det føles som hele gruppen løper om meg før jeg skjønner feilen. Til tross for det får Sigurd et greit utgangspunkt ca 45s bak tet, selv om jeg ikke er fornøyd over egen innsats.",
    },
    {
      desc: "Etterpå og erfaringer:",
      content:
        "Jeg er fornøyd over at jeg klarer å holde fokus og fart når jeg har noen å jakte. Spesielt i de vanskelige delene hvor jeg bare fokuserer på mitt eget løp jeg veldig bra. Da jeg derimot kom opp i tet og det ble lettere teknisk, ble det både hissig og til dels ufokusert orientering. Må bli bedre på å komme i ro når jeg er først og bare fortsette med solid orientering uten å føle at jeg blir presset av løpere bakfra. Må også stole på at når jeg løper bra er det ingen som vil prøve på å gjøre det bedre og etter hvert vil de få slite for å henge med. Til fremtidige NTNUI-løpere tror jeg det er viktig å lade opp mentalt for å klare pressen hvis man ikke har løpt på et bra lag i en sånn situasjon før. Tror største grunnen til at vi vinner i år er at vi allesammen er fokuserte, målinettet og har god selvtillit i både at vi er veldig vel forberedt teknisk, men også at alle har gjort jobben og er i bra form etter vinteren. Tror det er få lag som har så få svake lenker som NTNUI. Det hjelper også at NTNUI vant i 2023 og at alle da har troa på at vi klarer å få ut Eirik i tet på siste-etappen.",
    },
  ],
  runnerImage: "Albin-683x1024.jpg",
  gpsMapPath: "mapAlbin.jpg",
  runnerName: "Albin Warvelin",
  graphCaption: "Tid etter leder for Albin (lyseblå)",
});

Object.assign(legs[2], {
  text: [
    {
      desc: "Precamp:",
      content:
        "Årets precamp ble den lengste hittil. Den startet med Solrenningen helgen før Tiomila, før veien gikk videre til Sverige. For å forberede oss godt på mange og lange dager i Kolmården stoppet vi innom polkagriskokeriet i Gränna. Her fylte vi opp smågodtlagrene, og alt lå til rette for noen gode treningsdager. Trente ganske normalt frem til fredagen, men fokuserte mye på å gjøre en god teknisk jobb under hver trening. Visste at det ville bli viktig å være med teten inn på 3. etappe for at Mats skulle få et godt utgangspunkt, så jeg prøvde å gjøre de rette tingene slik at jeg skulle ha en bra dag når lørdagen endelig kom. Når startlistene til slutt dukket opp ble jeg likevel litt nervøs. Flere lag hadde satt ordentlig gode løpere på 3. etappen, og det kunne spesielt bli skummelt hvis Linné fikk ryggen fri ut på Långa. Skjønte derfor at jeg ikke hadde mange rom for feil hvis vi skulle være med teten.",
    },
    {
      desc: "",
      content: "",
    },
    {
      desc: "Løpet:",
      content: (
        <>
          Under oppvarmingen gikk jeg fra å være smånervøs til å bare bli
          supergira. Beina kjentes lette, og jeg visste at jeg behersket
          terrenget bra.
          <br />
          Gikk ut sammen med Göteborg 2 like bak teten. Göteborg 1 og Linné
          ligger litt foran så jeg åpner hardt for å riste av meg lagene rundt,
          samt ta innpå gutta foran. Får mine gaflinger bra, og ser etter hvert
          teten foran meg. Det løpes skikkelig fort frem til 5. post, og jeg får
          nok med å holde følge. Inn i det neste gaflingspartiet sprer alle
          løperne seg veldig, og jeg skjønner at det gjelder å ha god
          kartkontakt. Løper lenge med en god retning mot min 6. post, men
          mister kontrollen like før og blir usikker. Stopper opp og prøver å
          finne ut hvor jeg er, men skjønner ikke så mye. Klør meg litt i hodet
          før jeg plutselig ser posten til venstre for meg og løper bort og
          stempler. Tapte ikke alt for mye tid, men plutselig har mange lag som
          startet bak meg kommet forbi, og jeg prøver å ha fullt fokus de neste
          postene. Hele dette partiet er kraftig gaflet med mange tricky poster,
          men jeg tar meg tiden til å orientere godt, og finner alle mine
          kontroller på en fin måte. Til slutt kommer jeg sammen med Linné til
          TV-posten, og jeg skjønner at det gjelder å holde denne ryggen inn til
          mål.
          <br />
          Til 13. post er det et langstrekk og Linné svinger hardt til venstre
          for å løpe rundt på vei. Jeg ser kjapt på kartet og tenker at det
          umulig kan være et dårlig veivalg. Legger meg derfor i rygg og løper
          det jeg har. Snur meg et par ganger, men ser ingen bak oss. Synes vi
          løper fort på veien og når vi heller ikke ser noen foran oss begynner
          jeg å tenke at vi kanskje er i tet. Inn i 13. post tar vi plutselig
          igjen Göteborg 2 pluss noen andre lag. Hva faen? Disse har jeg ikke
          sett siden 2. post. Skjønner da at teten ligger et stykke foran oss,
          og vi fortsetter å holde trøkket oppe. På vei til 16. post kommer
          plutselig Anton Johansson forbi og jeg tenker at dette kan bli min
          lokfører opp til teten. Legger meg i rygg, og partiet fra 15. post til
          mål er kanskje det raskeste jeg har løpt i skogen noensinne. Anton
          løper som en villmann og jeg gjør det jeg kan for å holde følge. Etter
          hvert blir strikken tøyd mer og mer, og jeg begynner å frykte at vi
          kan havne i et vakuum bak teten. Heldigvis gjør de en liten feil inn i
          18. post, og jeg får kontakt igjen. Legger kartet i baklomma ned
          skråningen til 19. post og spurter som en gal på gressletten inn til
          mål. Kommer inn som nummer 6, et lite minutt opp til teten og med
          Linné like bak. Vi henger med!
        </>
      ),
    },
  ],
  runnerImage: "Sigurd-2048x1365.jpg",
  gpsMapPath: "mapSigurd.jpg",
  runnerName: "Sigurd Paulsen Vie",
  graphCaption: "Sigurd (gul, nederst) vs top 10 etappetid.",
});

Object.assign(legs[3], {
  text: [
    {
      desc: "",
      content:
        "Jeg hadde fått æren av å løpe den mest myteomspunnede og lengste nattetappen under årets 10Mila, Långa natten. Etter en vår med god trening og vårløp med mye middels orientering kom ikke dette som noen særlig overraskelse. Likevel; oppgavens alvor rant nedover ryggen som en bøtte med isvann sommeren 2014. (Noen som leser denne bloggen er kanskje for unge til å ta denne referansen. Det er en skremmende tanke for en etter hvert eldgammel NTNUI’er.)",
    },

    {
      desc: "",
      content:
        "Nils, Albin og Sigurd ga meg et utgangspunkt hvor min oppgave var enkel. Punktmarkere ryggen til Lukas fra start til mål. Godt. Da slapp jeg å vurdere og reflektere rundt egne evner til å orientere på natta. De siste timene brukte jeg på å spise. Passe på å spise nok for å unngå sprekk, men ikke for mye for å passe på den beryktede nattmagen. Under oppvarmingen prøvde jeg å bæsje, men fikk det ikke til. Dette gjorde meg litt urolig, men jeg kunne ikke tenke noe mer på det i det jeg gikk inn i båsen for jaktstarten.",
    },
    {
      desc: "",
      content:
        "Selve løpet var relativt monotont og kjedelig. Ikke så mye skjedde den første timen, annet enn at flere lag enn ønskelig kom bakfra. Jeg lot folk kjempe for plassene og sparte på krefter. I tillegg fulgte jeg med på kartet i stor nok grad til å stemple på alle postene. På slutten fikk vi et langt langstrekk med 4,5 km på sti og vei. Herlig! 3:28 var tempoet, og folk som var slitne før dette ble prellet av. På slutten følte jeg meg sprek, så jeg tok styringen de siste to postene før jeg begynte å spurte. Etter hvert fikk jeg et lite håp om at ledelsen jeg hadde kanskje kunne holde helt inn, så jeg begynte å knyte opp buksa. Så feil kan man altså ta. I siste sving ble jeg forbiløpt av min nye erkefiende Valter Pettersson. Kjedelig.",
    },
    {
      desc: "",
      content:
        "Etter jeg var ferdig med mitt løp var det bare å vente. Vente på at nattrevene så vidt skulle holde hodet over vann. Vente på at brikkene på den 8. og 9. etappen skulle falle i vår favør. Vente på at verdens beste O-løper atter en gang skulle bli undervurdert av motstanden og publikum. Vente på å få lov til å løpe jublende sammen med hele klubben over målstreken. Vi klarte det igjen!",
    },
  ],
  runnerImage: "Mats-1024x683.jpg",
  gpsMapPath: "mapMats.jpg",
  runnerName: "Mats Eidsmo",
  graphCaption: "Mats (grå) vs gjeng som kom bakfra, ettappetid",
});

Object.assign(legs[4], {
  text: [
    {
      desc: "Vinter:",
      content:
        "Grunntreningen denne vinteren kan karakteriseres av topper og daler. Kroppen var litt rar i starten av grunntreningen så jeg kom ikke inn i god trening før til jul. Jeg var i Stockholm i november for å ta et fag jeg trengte, og jeg fikk trent flere nattøkter i relevant terreng da. Etter jul fløt treningen på bra og jeg fikk trent bedre enn noen gang tidligere. Tanken denne vinteren var å fokusere på å trene fysikk i Trondheim, for så å kjøre mye o-tek under et par samlinger. Forsøkte å få en o-tek per uke i Trondheim i form av Mandagsplukk som jeg føler er en givende økt selv om det kan være en del snø. Det ble vintersamling i Italia i slutten av februar og samling i Halmstad i Sør-Sverige med Järfälla-gjengen i starten av mars. Ble syk etter begge samlingene. I Halmstad fikk jeg også irritasjon i en slimpose i hælen, sannsynligvis fordi jeg løp for mange økter på rad i et par nye o-sko. Så fikk hvile hælen ved å bruke tøfler i en uke. Etter det har jeg, frem til skrivende stund, ikke brukt o-sko igjen. Har løpt alt i stisko, som ikke presser like hardt mot hælen. Fungerte greit når det har vært tørt og man ikke har trengt pigg. Ble akkurat frisk og løpbar til de første testløpene. Ikke noe fart i kroppen etter mye sykdom, men løper stabilt teknisk. Får så et par uker med bra trening igjen for å kunne bygge form inn mot Tio.",
    },
    {
      desc: "Precamp:",
      content:
        "Ankommer precamp onsdag ettermiddag. Bestemte meg for å ikke løpe noe natt på precamp da jeg føler det påvirker søvnen for mye og 1–2 nattøkter til har kanskje ikke så mye å si for prestasjonen. Føler meg selvsikker for gjennomføringen av etappen min. Var mye mer nervøs i Skellefteå, men nå føler jeg meg rolig under precampen. Selv om jeg ikke er i mitt beste slag fysisk, vet jeg at det er o-teknikken som kommer til å bli avgjørende. På model event får jeg enda en bekreftelse på at dette er en terrengtype jeg kjenner godt. Armfeldtnatta ga i tillegg en fin bekreftelse på at jeg også kan løpe bra på natt, selv om jeg føler jeg er bedre på dagen. På arenaen begynner nervøsiteten å merkes litt, noe jeg forteller meg selv bare er positivt.",
    },
    {
      desc: "Løpet:",
      content: (
        <>
          S–1: Får gå ut i en stor tetgruppe som nr. 2, helt ifølge planen. Mats
          viser eksemplarisk opp kartet og jeg kan konstatere at det er riktig
          nummer. Jeg vil komme bra inn i løpet, så fokuserer ekstra på egen
          orientering til denne posten. Overrasket over hvor enkel posten var,
          men løypeleggeren forsøkte nok å lure folk fra denne gafflingen til å
          løpe venstreveivalget som var mer gunstig for de andre to gafflingene.
          Det kan lett skje hvis man har for stort fokus på å jakte lagene foran
          seg.
          <br />
          <br />
          1–4: Stor gruppe som samles sammen mot 2. post. Ser at det er en bra
          inngang til posten fra stikrysset. Dobbeltsjekker at jeg har god
          retning derfra og kan se kollen med posten allerede fra toppen på
          hjelpekurvekollen. Til 3. post splittes gruppa fra start, hvor de
          fleste av lagene løper høyre rundt skrentene, mens Linné, Kåre og jeg
          går mer venstre. Vi kommer sammen igjen nord for den åpne kollen. Da
          føler jeg at de andre begynner å dra for langt til høyre. Blir litt
          usikker, men ser på kompasset at jeg ikke skal samme vei som dem.
          Stoler på meg selv og det er en deilig følelse når jeg går rett i
          posten. Helt alene. Blir litt passiv når jeg ikke lenger ser noen
          andre lag, men kommer sammen med gruppa igjen i myra før 4. post. Nå
          er gruppa klart mindre, og jeg skjønner at noen må ha gått i feil
          gaffling. Viser seg at blant annet Linné skulle ha samme som meg.{" "}
          <br />
          <br />
          4–9: Er nå lengst frem i en gruppe. Løper mye på kompass her. Det er
          flatt og åpent så forsøker å speide mye sideveis for å få se detaljer
          jeg kan bruke i kombinasjon med retning. <br /> <br />
          9–10: Til 10. post starter jeg ut langs høydekurven med god retning.
          Får de to avlange høydepunktene og hjelpekurven på åsen bra. Flere i
          gruppa begynner her å dra mer oppover, men stoler på meg selv og får
          med meg noen. Tar retning mot åsen på andre siden av myra. Så skal jeg
          igjen ned, over en liten myr og opp på et kolleparti på andre siden.
          Får kollen med skrent, tar kompass og ser grense­røysa. <br /> <br />
          10–14: Løper ut på retning, får tårnet i kraftledningsgata og vet hvor
          jeg er. Følger det lange søkket mellom kollene. Tar god retning og
          leser nå på alle hjelpekoller og høydepunkter langs veien. Møter folk
          fra den andre gafflingen inn i posten. Merker at de skal mer høyre så
          drar distinkt mer venstre og får med Kåre. Får hjelpekollen ved
          slepstien og løper så opp på nordsiden av kollen på andre siden av
          stien. Får hjelpekollene ved myra bra. Får så de to høydepunktene,
          forsikrer meg om at jeg går opp på riktig sted på hjelpekollen før
          myra og ser da åsen hvor posten skal sitte. Til 14. post går jeg ned i
          myrsøkket og opp på kollen på andre siden. Løper på retning mot toppen
          og speider etter steinen i ringen som jeg ser tidlig. <br /> <br />
          14–15: I tet med Kåre med liten luke til resten. Løper ut på retning
          mot søkket og ser kollen med skrent på venstre side. Får hjelpekollen,
          det avlange høydepunktet og kollen bra, samt dobbeltsjekker med
          skrentrekka til venstre for å forsikre meg om at jeg er riktig.
          Krysser kraftledningsgata i søkket mellom kollene. Synes jeg får de to
          høydepunktene, men i etterkant tror jeg kanskje at jeg forveksler
          høydepunktet og hjelpekurveåsen med dem. Fortsetter på retning og
          kommer til søkket nord for den andre gafflingen, ser at Kåre tar en
          post på skrenten. Tenker da at posten sitter én skrent lenger vest og
          at jeg er ved søkket rett øst for min post. Løper da vest til neste
          søkk, men ingen post der. Tenker da at det kanskje var et søkk og at
          skrenten var for liten for å være med på kartet. Løper dit, men
          kodesifferet er feil som jeg trodde først. Tenker da fortsatt at
          posten sitter på skrenten mellom gafflingene, så løper tilbake til
          hvor jeg var først. Ser da at det er mer skrenter lenger vest, så
          skjønner at posten skal sitte bak de <br /> <br />
          15–M: Møter Linné på posten og vi er nå drøye minuttet bak. Merker at
          Linné vil trøkke på hardt nå, så tenker at jeg skal henge på, men være
          veldig nøye med orienteringen og roe ned så fort jeg blir litt
          usikker. Vi løper ut på stien og langs kanten på myra hvor vi passerer
          tre lag. Bra med på kartet i rygg på Linné frem til 17. post. Ser at
          18. post er siste vanskelige post som sannsynligvis er gafflet, så
          tenker at nå må jeg virkelig fokusere. Det er flere lag innen synshold
          nå. Får høydepunktet på andre siden av stien. Ser også kollen nord for
          strekket og følger den til steinen. Ser ofte på kompasset og får de to
          høydepunktene samt hjelpekollen. Tar en siste kompasskurs og går rett
          i posten. Kommer ned på stien og flere lag foran som tviler litt. Noen
          går venstre på stien og noen går mer venstre i skogen. Jeg kjører rett
          på og tenker å treffe en av passasjene mellom skrentene. Fortsetter på
          kompass og kommer ut på jordet og går rett i posten. Passerer Linné
          enkelt til sisteposten. Veldig bra lag, Linné, men én sak er sikker:
          de mangler spurtere. Ser Malung foran meg på oppløpet. Selvfølgelig
          kan man ikke være bak dem, så legger inn et ekstra gir for å gå om.
          Merker i hesteskoen rett etter mål at jeg har ganske mye syre i
          lårene, men det er bare å tygge på siste biten.
        </>
      ),
    },
    {
      desc: "Refleksjon og erfaringer:",
      content:
        "Etter bommen løper jeg raskere og mer offensivt enn tidligere. Kanskje ikke helt ifølge skoleboka å forsøke å løpe inn en feil. Men hadde hele tiden full kontroll på orienteringen. Lurer på om jeg hadde klart å løpe så raskt hele løypa uten at det hadde blitt flere feil. Føler at jeg klarer det på dagen, men det er en annen greie på natta.\n\nJeg tror en stor grunn til at vi vinner er at vi er en gjeng med felles mål som gjør store deler av treningen sammen. Dette medfører at vi i større grad enn andre klubber kan motivere hverandre til å gjøre jobben med eksempelvis natteknikken, men også lære av hverandre. Tror ikke det er noen annen toppklubb som trener like mye sammen som vi har gjort. Mitt beste råd til framtidige NTNUI’ere er å lære av hverandre. Det finnes mange flinke folk i NTNUI med mye erfaring. I forkant av mitt første Tio med NTNUI fikk jeg blant annet lære mye om natteknikk og stafettløping av NTNUI-legenden og nattreven Hans Petter «Hansi» Mathisen. Håper jeg klarte å videreformidle noe av min kunnskap til nyere NTNUI-ere under mitt siste år.\n\nHu og hei - Oskar",
    },
  ],
  runnerImage: "Oskar-1024x715.jpg",
  gpsMapPath: "mapOskar.jpg",
  runnerName: "Oskar Edvardsson",
  graphCaption: "Oskar (blå) vs top 8",
});

Object.assign(legs[5], {
  text: [
    {
      desc: "Prolog:",
      content:
        "Da jeg kom til Trondheim som fersk student tilbake i 2019 var det store ting på gang, med blant annet prosjekt 2020, prosjekt nattrev, return of Hansi, #vinnetioatru osv. Jeg ble etter hvert kjent som en stabil nattrev, med blant annet gode meritter fra løp som Byåsennatta, Torvnatta, Armfeldtnatta og NM-natta. Det ble trent mye natt, og med Audun på siste hadde vi troen på at vi kunne vinne Tio. Dessverre forsvant Tio i både 2020 og 2021 til korona, og da man var tilbake i 2022 og 2023 var jeg trygt plassert inne i andrelaget, både på grunn av skadeplager, men også på grunn av kjærlighet for ski-o og færre nattløp om høsten og vinteren. Fantastisk gøy å se gutta vinne i 2023, men man skulle jo gjerne vært på vinnerlaget selv. I fjor var jeg omsider inne på førstelaget, og da det ble snakk om prosjekt last dance i år skjønte jeg at jeg måtte komme meg på førstelaget om jeg også skulle få være med å vinne Tio med NTNUI (selvfølgelig mulig å vinne neste år også, jeg har i hvert fall trua!).",
    },
    {
      desc: "Forberedelser:",
      content:
        "Jeg prøvde å få løpt en del gjennom vinteren (typ 30–50 km og én hardøkt i uka), men ski-o var hovedfokus fram til EM i slutten av mars. Derfra var det full omstilling for å komme seg i akseptabel o-form på en måneds tid. Var temmelig utlada etter EM, noe som endte i en kræsjlanding på NM natt med 65. plass. Vurderte en stund å gi opp og heller satse på skareturer og rando denne våren, men jeg tok meg sammen og jobba meg inn på laget. Unngikk sykdom og typiske vårskader, og fikk trent bra. Både påskesamling og precamp var gode samlinger, og jeg følte meg trygg på egne og lagets evner.",
    },
    {
      desc: "Løpet:",
      content: (
        <>
          Oskar sender meg ut som nummer to, rett bak Kåre. Sykt gøy å løpe ut
          helt der framme! Med kort gafling i starten tar jeg fort teten, og
          løper omtrent perfekt de sju første postene. God kontroll på kart og
          kompass. Holder hodet kaldt, og lar meg ikke påvirke at jeg er
          (nesten) ensam i tät på Tio, noe som har vært en barndomsdrøm. Har for
          øvrig vært en barndomsdrøm å veksle først også, men man kan ikke få
          alt her i verden. <br /> Misforstår kurvene til 8. post og taper 20
          sekunder. Mot 9. og 10. post kommer Korti (Linné) og Ville (ST) opp i
          rygg og forbi. Tenker jeg fortsatt skal holde min rytme og orientere
          selvstendig, men begynner å gjøre større og større feil. Dårlig
          retning inn i 11. post (20 sekunder), veldig nølende til 12., og til
          14. post blir det 45 sekunders bom med Ville. På TV-post til og med,
          fryktelig flaut. Blir tatt igjen av en gjeng, og løper på rygger rett
          i feil gafling til 15. Panikken kommer fort, men drar frem
          stafettreglene og bommeregelen jeg lærte i Asker en gang i tiden, som
          alltid ble dratt frem før Tio. To føtter i bakken, og jeg skjønner
          fort hvor jeg måtte være, så bommen blir begrenset til et lite minutt.{" "}
          <br /> Fryktelig irritert på meg selv, skjønner at hvis jeg ikke
          skjerper meg nå så forsvinner toget for godt. Det kan jeg ikke leve
          med, så jeg skjerper meg, får kart og terreng til å stemme overens
          igjen og plukker de siste postene bra. Har ikke tenkt noe særlig på
          det fysiske underveis på etappen, men er helt fullstendig knekt i
          spurten, så har nok pushet bra hele veien. Fryktelig letta når jeg
          hører at jeg bare er litt over minuttet bak tet, var redd det skulle
          være typ tre minutter. Var også redd for at luka jeg skapte opp til
          tet skulle bli avgjørende, men gutta løper jo bra, så den blir ikke
          avgjørende. God stemning å følge de siste etappene, og da Eirik lagde
          seg en luke var jeg aldri i tvil om at det skulle bli seier! <br />
          Med de prioriteringene jeg har gjort de siste årene kan jeg ikke be om
          så mye mer som o-løper.
        </>
      ),
    },
  ],
  runnerImage: "VegardImage.png",
  gpsMapPath: "mapVegard.jpg",
  runnerName: "Vegard Gulbrandsen",
  graphCaption: "Vegard (lys grønn) vs top 8",
});

Object.assign(legs[6], {
  text: [
    {
      desc: "Forberedelser:",
      content:
        "Tiomila er selvfølgelig det man trener mot hele vinteren og våren, og alle fellestreninger går til diskusjoner om hvordan laget skal se ut og hvem som skal løpe hvilke etapper. Jeg hadde en suboptimal treningsvinter med et nokså kort skadeavbrekk, og klarte ikke å få noe særlig kontinuitet i treninga. Selvtilliten var dermed ikke på topp ved sesongstart. Det ble ikke bedre med en fadese på NM natt, hvor ingenting stemte, og mye så mørkt ut. Jeg klarte derimot å omstille, og skrape sammen noe form som kunne brukes til en kort, gafla nattetappe. De siste ukene før Tiomila fikk jeg virkelig troa på at vi kunne få til noe stort, med mye god trening både på påskesamling og precamp. Gutta som løper etappene før meg gjør som de skal, og jeg får løpe ut langt fremme, men samtidig nokså alene som nummer 6, 1:19 bak tet.",
    },

    {
      desc: "",
      content: "",
    },
    {
      desc: "Underveis:",
      content:
        "Jeg løper mot startpost og ser at løypa jeg skal løpe er kort. Da skal det jo ikke være nødvendig å spare på noen krefter, vel? Løper derfor hardt mot 1. post, men går selvfølgelig på en liten bom. Huff, dårlig start. Kanskje det er greit å ha litt kontroll allikevel. Plukker 2. post fint, men igjen er jeg unøyaktig og overivrig og mister kontrollen på vei inn i 3. post. Får litt panikk og tenker at det var fryktelig unødvendig. Etter andre advarsel setter jeg ned tempoet litt, og plukker de neste postene fint. Har ikke peiling på hvordan jeg ligger an, men antar jo at jeg har tapt en god del. Og det hadde jeg også.\n\nTil 7. post gjør jeg samme feilen som tidligere; jeg løper alt jeg har uten mål og mening og glemmer å lese kartet. Da mister jeg kontrollen og må bruke masse tid på å finne ut av hvor jeg er. Irriterende. Nå må jeg virkelig skjerpe meg. Beiner det jeg har ut av posten og føler jeg har god kontroll, frem til jeg ikke har det lenger. Ny bom på 8. post. Får traumer tilbake til NM natt. Nå er det nok, tenker jeg. Skal man løpe på førstelaget til NTNUI på Tiomila skal man ikke være så idiot som jeg har vært så langt i løpet.\n\nHeldigvis klarer jeg denne gangen å nullstille, og gjør et bra løp siste tredjedel. Blir motivert av å ta igjen SNO og Ravinen igjen, og pusher på helt inn til mål. Når man kommer ned på jordet inn mot sistepost og hører Mats rope: «No må du spurt, Anders!», da spurter man. Veksler som nummer 5, 2:52 bak tet, og sender Sander ut på jakt.",
    },
    {
      desc: "Etter løpet:",
      content:
        "Totalt sett er jeg ikke fornøyd med eget løp, og har alt for mange feil til å kunne kalle det noe annet enn dårlig. Men heldigvis var den fysiske formen god, så jeg klarer å holde tempoet oppe til å ikke tape alt for mye tid til teten. Etter eget løp er man selvfølgelig helt tom, både i hodet og kroppen. Men etter en god dusj og mye godteri kan man kose seg mens man følger med på de fantastiske lagkameratene som løper nydelig orientering.\n\nDet er jo nesten uvirkelig at vi skulle klare å vinne enda en gang, og vi skal virkelig være stolte av at vi klarer å samle en så stor og god gjeng som er i stand til å vinne en såpass prestisjetung og stor stafett. I tillegg var det jo spesielt når det var mitt siste Tiomila for NTNUI <3.",
    },
  ],
  runnerImage: "Anders-1024x718.jpg",
  gpsMapPath: "mapAnders.jpg",
  runnerName: "Anders Vestøl",
  graphCaption: "Anders (grønn) vs top 6",
});

Object.assign(legs[7], {
  text: [
    {
      desc: "Forberedelser:",
      content:
        "Fikk trent veldig godt i vinter, og hadde store forhåpninger før sesongen. Dessverre pushet jeg det en smule for langt i overgangen fra vintertrening til mer konkurranser, og endte opp med overbelastning i lårene. Måtte derfor ha en ganske rolig treningsperiode i 3–4 uker rundt påsketider, som gjorde godt for lårene, men det satte meg ganske langt tilbake resten av våren. Hadde derfor ganske lav selvtillit da jeg dro på precamp, siden sesongen hittil hadde vært en gedigen skuffelse. Fikk meg noen gode økter på precamp og fikk inntrykk av at terrenget passet meg bra, så fikk etter hvert giret meg opp mot helgen og hadde troen på at dette skulle gå fint.",
    },
    {
      desc: "",
      content: "",
    },
    {
      desc: "Løpet:",
      content:
        "Fulgte spent med på stafetten før min egen etappe, og så at gutta leverte varene. Ble sendt ut som nummer 5, 2:52 bak, i en gruppe med Ravinen og SNO. Hadde 30 sekunder opp til Tuna, så vi åpnet friskt for å prøve å hente ham. Så lykta hans der fremme hele tiden, men det var irriterende hvor vanskelig det var å løpe ham inn. Ravinen lå for det meste fremme og dro, mens jeg løp bak og holdt kontrollen som en backup. Vi plukket de fire første postene bra.\n\nSå kom det korteste strekket på løypa (5. post), hvor vi sannsynligvis skapte god underholdning på TV-post. Jeg var 98 % sikker på at jeg plukket to streks myr og gul kolle inni ringen, og sånn sett skulle jeg ha svingt av mot venstre ned i post, men jeg kunne se lykta til Tuna litt lenger frem som dro mot høyre. Det samme gjorde Ravinen, og da klarte jeg ikke å stole 100 % på meg selv og ble dratt med mot høyre. Vi møtte etter hvert på Tuna som var på vei tilbake igjen, og etter noen sekunders betenkning skjønte jeg at da måtte vi være for langt til høyre. Dro tilbake dit vi kom fra og deretter ned venstre som jeg hadde tenkt først, og der satt posten. Veldig irriterende å være så nærme og likevel legge igjen ett minutt. Som man også kan se på TV-post, så var vi bare 20–30 meter bortenfor posten, men likevel så surret vi rundt et helt minutt. Fikk plukket Tuna på den bommen, men dyrebar tid forsvant opp til tet.\n\nEtter bommen var det egentlig ikke så mye spennende som skjedde. Vi var en gruppe på fire som løp i godt tempo og ganske rent. Den manglende treningen denne våren gjorde at jeg ikke hadde noe særlig å bidra med fartsmessig, ble bare liggende bak i gruppa og syntes det gikk fort nok. Syntes også veivalgene var ganske innlysende; det gjaldt å holde seg nærme streken og få korteste vei. Vekslet Isak ut som nummer 6, 3:28 bak tet.",
    },
    {
      desc: "Refleksjon:",
      content:
        "Tatt vårsesongen i betraktning er jeg fornøyd med løpet. Ja, fikk et minutt bom på 5. post som var irriterende siden jeg jo tydeligvis visste hvor jeg var, men det er lett å si i ettertid. Gjorde ingen store feil og hadde godt tempo, så kan ikke klage noe på det. Og det er det stafett handler om. Så lenge alle på laget leverer som normalt, så holder det veldig langt, og denne gangen holdt det til seier. Veldig stort å få oppleve å vinne Tiomila, ikke bare én, men to ganger. Kunne ikke bedt om noe mer i min siste sesong i NTNUI.",
    },
  ],
  runnerImage: "Sander-1024x718.jpg",
  gpsMapPath: "mapSander.jpg",
  runnerName: "Sander Arntzen",
  graphCaption: "Sander (rød-brun) vs top 5",
});

Object.assign(legs[8], {
  text: [
    {
      desc: "Før løpet:",
      content:
        "Fin inngang til stafetten hvor det føltes ut som laget var ordentlig skjerpet, og jeg tror egentlig det er en fin inngang for NTNUI å ikke komme inn med altfor mye selvtillit. Sånn sett bra, tror jeg, at flere av gutta følte de ikke helt hadde fått ut sitt potensial under våren. Selv var formen solid og jeg hadde god selvtillit på egne ferdigheter teknisk og fysisk. Morsomt å få ansvaret for en av de tøffere og viktigere etappene, så jeg så veldig fram til det.",
    },
    {
      desc: "",
      content: "",
    },
    {
      desc: "Under løpet:",
      content:
        "Fint og morsomt utgangspunkt etter fin innsats av de andre gutta. Linné ca. 3,5 min foran, HS knappe 2, og sammen med Ravinen, Tuna og SNO. Klar taktikk om å stole på egen orientering og egne valg.\n\nJeg løper lenger på stien til 1. post. Taper litt, men er i kontakt over hogsten og inn mot post. Deler oss ut av posten igjen når de skal til sin gaffling. Tar 2. post greit, usikker inn i 3. fra skrenten, leser meg inn på det gule. Ser HS og de andre jeg gikk ut med litt foran over hogsten, men stresser ikke med å løpe dem inn; venter til jeg kan orientere dem inn i stedet. Løper mer direkte til 5. post og krysser dem nærmest litt før posten.\n\nDeler oss på strekkene litt videre også, men har for det meste bra kontroll og oversikt. SNO puster tungt på halen, men ellers føles de andre passelig komfortable. Sammen med HS på min gaffling på 12 og ser at vi krysser Tuna og Ravinen til 13. HS forsvinner fra min rygg inn mot posten, men jeg får den bra og møter Tuna og Ravinen igjen på stien til 14. SNO er også borte. Taper litt på unøyaktighet før traktorslepet, så ligger litt bak opp mot posten. Tar min gaffling alene på 15 og får igjen noen meter opp.\n\nHar god kontakt inn mot 17 hvor vi plutselig også ser Linné. Veldig deilig følelse, men også ganske overrasket da jeg ikke synes vi har løpt veldig bra eller veldig fort. Tar kommando mot 18 og 19, blir passert av Ravinen inn i 19 og tar ryggen hans til mål. Må slippe litt ned mot jordet og enda litt mer på beininga. Uansett veldig god innsats og deilig å kunne sende ut Eirik med teten. Eirik viser hvem som styrer sjappa og setter de andre på plass. Deilig og veldig, veldig moro!",
    },
    {
      desc: "Etter løpet:",
      content:
        "Imponert over oss selv som lag at vi klarte å vinne Tio igjen, selv om jeg tenker at vi avgjør denne stafetten på en litt annen måte. I 2023 var vi aldri spesielt langt bak tet og de aller fleste på laget løper etapper som er virkelig gode, kanskje med unntak av meg selv. I år mener jeg at den gjennomsnittlige kvaliteten på gjennomføringen av etappene er like god, men at vi vinner på å ha en verdensstjerne på siste etappe.\n\nTenker også at vi kanskje er litt heldige at utviklingen blir som den blir på de to siste etappene; det kunne ganske lett gått en helt annen vei. Men det spiller ingen rolle nå, og det er uten tvil slik at hele laget, og ikke minst resten av klubben, har et resultat vi kan være veldig stolte av.\n\nJeg tenker det blir viktig for klubben og treningsmiljøet at man prøver å fortsette å ta nytte av de gode årene som har vært, selv om en del av herreløperne som har vært på førstelagene de siste årene forsvinner. Man kan ha selvtillit på at den treningsjobben som har vært gjort i fellesskap de siste årene står seg veldig bra, og jeg er helt sikker på at ledige plasser på lagene kommer til å fylles av løpere som tar steg etter å ha deltatt aktivt i treningsmiljøet og hverdagen.\n\nOg det vil naturligvis være like viktig at breddeløperne deltar på trening (eller Tiomøter, samlinger og annet). Dere er også ekstremt viktige bidragsytere for at løperne med førstelagsambisjoner kan ta steg. Da vil man kunne være med å kjempe om topplasseringer i mange år fremover også!",
    },
  ],
  runnerImage: "Isak-1024x718.jpg",
  gpsMapPath: "mapIsak.jpg",
  runnerName: "Isak Jonsson",
  graphCaption: "Isak (rød-brun aktig) vs top 4",
});

Object.assign(legs[9], {
  text: [
    {
      desc: "Før løpet:",
      content: (
        <>
          Jeg må innrømme at jeg ikke så spesielt lyst på Tiomila etter helgen i
          Kristiansand. Utenom Isak gjennomfører vi jevnt over mildt sagt
          dårlig. Videre gjennom våren blir jeg mer og mer betrygget på at laget
          ikke er så aller verst. De tekniske prestasjonene svingte mye, men jeg
          syntes mange så fysisk sterke ut og leverte godt på sine beste økter
          og løp. Fint er det også at Anders går fra å synes formen er dårlig
          til å være usikker på formen på Strava, Sander rekker ikke å bli i god
          nok form for sin egen teknikk, og Vegard får ristet ski-o-beina sine
          ordentlig. Det gjør at jeg får skikkelig troa når vi nærmer oss
          løpshelgen.
          <br /> <br />
          Min egen vintertrening har vært upåklagelig. Jeg har ikke jobbet meg i
          hjel, treninga har rullet på med jevne og fine uker og samlingene har
          vært gode. Nytt av året prøvde jeg å kjøre ekstra hardt med dobbel
          samling, landslag pluss påskesamling i to uker, med to o-økter hver
          dag, før fem helt løpefrie dager i fjellet. Dette to uker før Tiomila,
          så det var spennende å møte opp på SL dager før Tiomila. Antageligvis
          hadde jeg bare godt av å bli banket med over tre minutter av
          lokalløpsmafiaen. Jeg gikk mer nervøs inn i helgen, men også mer
          skjerpet. <br />
          <br />
          Jeg kan like en lang precamp når været er fint og vi bor et fint sted,
          ellers tenker jeg vanlig precamp holder fint. Jeg vil ikke råtne bort
          i en liten campinghytte i regnvær. Jeg tror det hjelper at laget er
          relativt rutinert og har fra tidligere rutiner på hva de vil gjøre de
          siste dagene. Og vi er gode til å gjøre «some stupid shit».
        </>
      ),
    },

    {
      desc: "",
      content: "",
    },
    {
      desc: "Løpet:",
      content: (
        <>
          Isolert sett som sisteetappeløper kan jeg like det nye konseptet som
          lar meg se mye mer av stafetten enn jeg ellers hadde fått gjort. Jeg
          legger meg lykkelig vitende om at vi er i tetgruppa ut på Långa. Jeg
          får en grei natt der jeg stort sett ligger våken, men også får et par
          timer på øyet før alarmen ringer. Jeg spiser godt før jeg rekker å bli
          nervøs igjen og drar til arena sammen med Isak. Inngangen på løpet er
          drømmescenarioet der spenningen stiger mens Isak løper oss nærmere og
          nærmere teten. Jeg prøver å ikke begynne oppvarmingen for tidlig mens
          jeg skuler bort på de andre sisteløpernes lyktvalg.
          <br />
          <br />
          Ravinens gode avslutning på niende etappe setter føringer for
          åpningstempoet. Jeg er livredd for at Bergmann skal gå på direkten, så
          etter at jeg får kontroll på langstrekket i starten blir første
          oppgave å tette luka, og jeg snur meg én gang og ser at Linné og Tuna
          tenker det samme. Vi løper fort på grusveien og stiene i starten av
          strekket og jeg konstaterer at beina kjennes bra ut. Andre halvdel av
          strekket løper jeg traséen jeg mener er best, noe som gjør at jeg
          skilles fra de tre andre, men vi møtes igjen noen hundre meter senere.
          Felles førstepost.
          <br />
          <br />
          Igjen skilles gruppen og jeg løper min andre post bra og føler Linné i
          rygg. De to andre har jeg ikke kontroll på, så jeg fortsetter å løpe
          fort mot den tredje posten.
          <br />
          <br />
          På den tredje posten er det kartvending. Jeg styrer litt frem og
          tilbake og vender kartet flere ganger på veien før inngangen til den
          tredje posten, og jeg får ikke snudd kartet skikkelig før jeg ser
          posten. Jeg synes stien langs vannet ser innbydende ut og bestemmer
          meg for å løpe rundt. Strever litt med kartlesingen på vei ut av
          posten, men bestemmer meg bare for å løpe på kurs. Jeg har først
          kontroll når jeg er på hogstfeltet på vei ned bakken. Nå tenker jeg
          litt mer på konsekvensene av valget og bestemmer meg for å løpe enda
          hardere på. Toppscenarioet er å ha lurt til seg en luke, men jeg kan
          ikke ta sjansen på samme fart og miste de andre. På vei inn i 4. post
          speider jeg mot høyre, bestemmer meg for at det er jeg som er i tet og
          trykker på videre.
          <br />
          <br />I det neste partiet er jeg veldig godt fornøyd med den tekniske
          gjennomføringen. Planen nå er å kaste alle kortene på bordet og å løpe
          i en hardere fart enn jeg kan holde helt inn til mål. Det innerste
          partiet av løypa er jeg veldig godt fornøyd med. Terrenget var
          innbydende med vekslende karakter og tempo, og jeg var skarp og
          konsentrert. Jeg minnes i skrivende stund at jeg nøt det fine
          morgenlyset, irriterte meg over at jeg kom én skrent til høyre midt på
          strekket til den 8. posten og at lyngen over til 12. post føltes som
          en evighet.{" "}
          <i>
            Jeg latet som det var jeg som jaget, men nøt at de andre jaget meg
            mens jeg post for post nærmet meg hjemreisen
          </i>
          .
          <br />
          <br />
          Løpinga tilbake til arena var preget av sti- og veiløping,
          orienteringen enklere og fokuset på å orke å løpe hardt helt inn.
          Etter å ha skrudd min lille hodelykt av og på et par ganger, bestemte
          jeg meg på vei til den 19. posten for å legge lykta på en drikkepost.
          Den så jeg aldri igjen. På vei til den 20. posten snudde jeg meg på
          veien for å se bakover og pustet lettet ut. Videre mot 21. kom jeg inn
          i traséen til dagløperne, løp i tråkkene i retning posten og fikk den
          fint. Ned mot arena ventet en kameramann. Jeg stresset litt, men fant
          fint de siste to postene i lia før det siste jordet ventet.
          <br />
          <br />
          Jeg får noen tomler opp av tilskuere langs gjerdet, men ser ikke laget
          før jeg bikker toppen av jordet og ned mot sistepost. Å komme over
          kanten av bakken, først se lagkameratene og videre hele klubben, var
          umåtelig deilig. Det kan ikke beskrives, men jeg har det kjært i
          minnet. Jeg blir glad av å tenke på minnene.
        </>
      ),
    },
  ],
  runnerImage: "Eirik-1024x683.jpg",
  gpsMapPath: "mapEirik.jpg",
  runnerName: "Eirik Langedal Breivik",
  graphCaption: "Eirik (lilla),  Bergmann og Svensk (lys lilla og gul)",
});

/*
Object.assign(legs[0], {
  text: [],
  runnerImage: "TODO",
  gpsMapPath: "TODO",
  runnerName: "Navn Navnesen",
  graphCaption: "TODO",
});
*/
export default legs;
